import withSettingsColor from '../../app/hoc/with-settings-color';
import { CARD_BORDER_COLOR_PATH } from '@wix/communities-forum-client-commons/dist/src/constants/wix-params-rpw';

export default withSettingsColor({
  path: CARD_BORDER_COLOR_PATH,
  propName: 'borderColor',
  siteColorFallback: 'color-5',
  siteColorAlpha: 0.2,
});
